import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES, TARGETS } from 'app-webtech-core/beacon/const';
import { selectors } from 'app-webtech-core/selectors';
import { getPlaybackData } from './helpers/getPlaybackData';

/*
Fires when there is an error loading/playing the video (at any point during the User's session).
 */

// eslint-disable-next-line no-unused-vars
export const msnVideoErrorBeacon = (action, prevState, nextState) => {
  const { payload } = action;
  const beaconHdr = {
    hitType: HIT_TYPE.EVENT,
    targets: TARGETS.MSN,
    label: payload && payload.type ? payload.type : 'Generic Error',
    value: payload && payload.message ? payload.message : JSON.stringify(action),
    ...getPlaybackData(nextState),
  };
  const { currentPlayingAd } = selectors.playbackSession.properties(prevState);
  let beacon;
  if (currentPlayingAd) {
    beacon = {
      ...beaconHdr,
      eventCategory: EVENT_CATEGORIES.CM,
      eventName: EVENT_NAMES.CM_ERROR,
    };
  } else {
    beacon = {
      ...beaconHdr,
      eventCategory: EVENT_CATEGORIES.QOS,
      eventName: EVENT_NAMES.VIDEO_ERROR,
    };
  }
  return beacon;
};
